import React from "react";
import { Routes, Route } from "react-router-dom";

import Sidebar from "../components/common/Sidebar";
import "../styles/dashboard/Admin/AdminPortal.css";

// Admin Components
import AdminHome from "../components/dashboard/Admin/AdminHome";
import SubAdminReportManagement from "../components/dashboard/Admin/SubAdminReportManagement";
import ReportManagement from "../components/dashboard/SubAdmin/ReportManagement"; // Shared organization reports

// Import shared components
import OrganizationManagement from "../components/dashboard/shared/OrganizationManagement";
import SubAdminManagement from "../components/dashboard/shared/SubAdminManagement";
import UserManagement from "../components/dashboard/shared/UserManagement";
import TransactionHistory from "../components/dashboard/shared/TransactionHistory";
import CreditReportManagement from "../components/dashboard/shared/CreditReportManagement";
import KycVerificationManagement from "../components/dashboard/Admin/KycVerificationManagement";
import UploadDataManagement from "../components/dashboard/shared/UploadDataManagement";
import BankAct from "../components/dashboard/shared/BankAct";
import SupportTicketManagement from "../components/dashboard/shared/SupportTicketManagement";
import Notifications from "../components/dashboard/shared/Notifications";
import Profile from "../pages/Profile";
import RegistrationRequests from "../components/dashboard/SuperAdmin/RegistrationRequests";

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  return { Authorization: `Bearer ${token}` };
};

export default function AdminPortal() {
  return (
    <div className="dashboard-layout">
      <Sidebar role="Admin" />
      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<AdminHome />} />
          <Route path="dashboard" element={<AdminHome />} />
          <Route path="sub-admins" element={<SubAdminManagement role="admin" />} />
          <Route path="sub-admin-reports" element={<SubAdminReportManagement />} />
          <Route path="organizations" element={<OrganizationManagement role="admin" />} />
          <Route path="reports" element={<ReportManagement role="admin" />} />
          <Route path="users" element={<UserManagement role="admin" />} />
          <Route path="transaction-history" element={<TransactionHistory role="admin" />} />
          <Route path="credit-reports" element={<CreditReportManagement role="admin" authService={{ getAuthHeader }} />} />
          <Route path="kyc-verifications" element={<KycVerificationManagement />} />
          <Route path="uploaded-data" element={
            <UploadDataManagement
              role="admin"
              uploadEndpoint="/v1/admin/data-upload/upload"
              historyEndpoint="/v1/admin/data-upload/history"
              authHeader={() => require('../services/orgUserAuth.service').default.getAuthHeader()}
              orgSelection={true}
              organizations={[]}
            />
          } />
          <Route path="bank-act" element={<BankAct role="admin" />} />
          <Route path="support-tickets" element={<SupportTicketManagement role="admin" />} />
          <Route path="registration-requests" element={<RegistrationRequests />} />
          <Route path="notifications" element={<Notifications role="admin" />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<h2>404 - Page Not Found</h2>} />
        </Routes>
      </div>
    </div>
  );
}
